// Select the toggle trigger
const toggles = document.querySelectorAll(".footer__toggle");

// Create div to contain backdrop
// var node = document.createElement('div');
// node.classList.add('modal-backdrop');
const footerBackdrop = document.querySelector(".footer__backdrop");

function toggleFooter() {
    if (document.body.classList.contains("footer-open")) {
        document.body.classList.remove("footer-open");
    } else {
        document.body.classList.add("footer-open");
    }
}


// Toggle body class 'footer-open'
if (toggles) {
    toggles.forEach(toggle => toggle.addEventListener("click", toggleFooter));
}

// Close footer on click on backdrop
if (footerBackdrop) {
    footerBackdrop.addEventListener("click", function () {
        toggleFooter();
    });
}
